<template>
  <div class="contact-container" :class="{
    isMobile: isMobile()
  }">
    <div class="block-title">联系我们</div>

    <div class="title" style="marginBottom:14px;">
      您有任何问题都可随时联系我们
    </div>

    <div class="display-box flex">
      <div class="flex common-block1">
        <div class="icon icon1"></div>
        <div class="right-content">
          <div class="t1">电话</div>
          <div class="t2">010-5852 8506</div>
        </div>
      </div>
      <div class="flex common-block2">
        <div class="icon icon2"></div>
        <div class="right-content">
          <div class="t1">邮箱</div>
          <div class="t2">foundation@catzgroup.com</div>
        </div>
      </div>
      <div class="flex common-block3">
        <div class="icon icon3"></div>
        <div class="right-content">
          <div class="t1">地址</div>
          <div class="t2">北京市西城区闹市口大街1号长安兴融中心4号楼11层</div>
        </div>
      </div>
    </div>

    <div class="title" style="marginBottom:22px;">
      您也可以通过网站给我们留言：
    </div>

    <submitForm />
  </div>
</template>

<script>
import submitForm from './form'
import { isMobile } from '@/utils/index'

export default {
  components: {
    submitForm
  },
  data() {
    return {

    }
  },
  methods: {
    isMobile
  },
  created() {

  }
}
</script>

<style lang="scss">
.contact-container {

  &.isMobile {
    .display-box {
      display: block;

      .flex {
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0px;
        }
      }
    }
  }

  .title {
    font-size: 14px;
    font-weight: normal;
    color: #0A1121;
  }

  .display-box  {
    padding: 47px 31px;
    // background: #FFFFFF;
    background: #F4F7FC;
    // border: 1px solid #DDE5F2;
    border-radius: 6px 6px 6px 6px;
    margin-bottom: 42px;

    .common-block1 {
      flex: 0 0 27%;
    }
    .common-block2 {
      flex: 0 0 38%;
    }
    .common-block3 {
      flex: 0 0 35%;
    }


    .icon {
      width: 32px;
      height: 32px;
      margin-right: 16px;
      flex-shrink: 0;

      &.icon1 {
        background: url(~@/assets/lx1.png) no-repeat;
        background-size: 100% 100%;
      }

      &.icon2 {
        background: url(~@/assets/lx2.png) no-repeat;
        background-size: 100% 100%;
      }

      &.icon3 {
        background: url(~@/assets/lx3.png) no-repeat;
        background-size: 100% 100%;
      }
    }

    .right {
      .t1 {
        font-size: 14px;
        color: #0A1121;
      }
      .t2 {
        font-size: 14px;
        color: #0A1121;
      }
    }
  }
}
</style>
